import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[pimModalHost]',
    standalone: false
})
export class ModalHostDirective {
	constructor(public viewContainerRef: ViewContainerRef) {
	}
}
